import { Stack, Text } from '@mantine/core';

// A partner's logo with "powered by hellohousing" under it (#2357), where hellohousing's own logo
// would otherwise be: the sidebar while a partner plan is active, and the redeem page of a
// partner's code. `partner` is an entry of helpers/partners.js.
// "hellohousing" is text in the same line as "powered by", so both share size and baseline.
const PartnerBranding = ({ partner, logoHeight = 64, gap = 8 }) => (
  <Stack gap={gap} align="center">
    <img src={partner.logo} alt={`${partner.name} Logo`} style={{ height: logoHeight, maxWidth: '100%' }} />
    <Text component="span" size="xs" c="#727293" ta="center" style={{ lineHeight: 1, whiteSpace: 'nowrap' }}>
      powered by <Text component="span" inherit fw={700} c="#13135C">hellohousing</Text>
    </Text>
  </Stack>
);

export default PartnerBranding;
